'use client';

import { toast } from 'sonner';

export const getErrorMessage = (error: unknown, fallback: string) => {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === 'string' && error) return error;
  return fallback;
};

export const copyToClipboard = async (text: string) => {
  if (typeof navigator === 'undefined') return;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', 'true');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

export const showErrorToast = (error: unknown, fallback: string) => {
  const message = getErrorMessage(error, fallback);

  toast.error(message, {
    duration: Number.POSITIVE_INFINITY,
    closeButton: true,
    action: {
      label: 'Copy',
      onClick: () => {
        void copyToClipboard(message)
          .then(() => {
            toast.success('Copied to clipboard');
          })
          .catch(() => {
            toast.error('Failed to copy', { closeButton: true });
          });
      }
    }
  });
};
